// Export all interfaces
export * from './lib/personality.interfaces';

// Export personality presets
export * from './lib/personalities';

// Export canonical product → personality mapping
export * from './lib/product-personalities';

// Export per-personality component composition
export * from './lib/personality-composition';

// Export distinctiveness metric (Workstream C1)
export * from './lib/personality-distinctiveness';

// Export utility functions
export * from './lib/color-utils';
export * from './lib/color-harmony';
export * from './lib/contrast-utils';
export * from './lib/palette-migration';
export * from './lib/tradecraft-theme';
export * from './lib/sovereign-vault-theme';
export * from './lib/industrial-nexus-theme';
export * from './lib/civic-clear-theme';

// Export rendered-distinctiveness metric (compares emitted CSS variables).
// personality-color's hexToRgb collides with color-utils, so export selectively.
export {
  deltaE,
  isHex,
  hexToLab,
  mix,
  chroma,
  hslToHex,
  hexToHsl,
  rgbToHex,
  hexToRgb as personalityHexToRgb,
} from './lib/personality-color';
export type { Hsl } from './lib/personality-color';
export * from './lib/rendered-distance';
